<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12">
        <div class="text-h5 font-weight-regular">
          Website liên kết
        </div>
      </v-col>
      <v-col cols="12">
        <v-sheet
          class="mx-auto"
          elevation="0"
        >
          <v-slide-group multiple show-arrows="always">
            <v-row v-if="loading" justify="center" align="center" class="my-1">
              <v-slide-item v-for="(item, index) in 10" :key="`load${index}`">
                <v-chip
                  pill
                  class="ma-5 pa-8"
                >
                  <v-skeleton-loader
                    type="list-item-avatar"
                    class="weblink-loading-card"
                  ></v-skeleton-loader>
                </v-chip>
              </v-slide-item>
            </v-row>
            <v-row v-else justify="center" align="center" class="my-1">
              <v-slide-item v-for="(item, index) in items" :key="index" v-slot="{ active, toggle }">
                <v-chip
                  pill
                  class="ma-5 pa-8"
                  @click="toWebLink(item.link)"
                >
                  <v-avatar left>
                    <v-img :src="`${apiBaseUrl}/uploads/${item.logo}`" contain/>
                  </v-avatar>
                  {{ item.name }}
                </v-chip>
              </v-slide-item>
            </v-row>
          </v-slide-group>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    name: 'WebLink',
    data () {
      return {
        model: null,
        loading: false,
        items: []
      }
    },
    computed: {
      ...mapState([
        'config'
      ]),
      apiBaseUrl() {
        return this.config.beUrl;
      }
    },
    mounted () {
      this.getItems();
    },
    methods: {
      getItems () {
        this.loading=true;
        axios.get("api/v1/public/home-web-links")
          .then(response => {
            this.items = response.data;
            this.loading=false;
          })
          .catch(function (error) {
            console.log(error);
            this.loading=false;
          });
      },
      toWebLink(link){
        window.open(link, '_blank');
      }
    }
  }
</script>

<style>
  .weblink-loading-card .v-skeleton-loader__list-item-avatar{
    width: 150px; 
    background: transparent !important;
  }
</style>